// MUI Imports
import {
  Box,
  Button,
  Grid,
  Backdrop,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  IconButton,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useState } from "react";


// Icon Imports
import Icon from "../../components/icon";
import AddIcon from "@mui/icons-material/Add";

// ** Custom Component Imports
import CustomAvatar from "components/avatar";

// ** Component Imports
import LineItems from "screens/Assessments/component/LineItems";
import CreateBundleDialog from "./component/CreateBundle";
import CreateServiceDialog from "./component/CreateService";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog";
import useMediaQuery from "@mui/material/useMediaQuery";

// ** Logic Imports
import { useIndexLogic } from "./logic/index-logic";
import { useServicePermission } from "./permissions/ServicePermissions";
import { useTheme, styled } from "@mui/material/styles";

// Layout Imports
import UserLayout from "../../components/layouts/UserLayout";

import { toast } from "react-toastify";
import CustomTextField from "components/mui/text-field";
import ImportExportOptions from "components/ImportExportOptions";

const Services = () => {
   const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const [openServiceDlg, setOpenServiceDlg] = useState(false);
  const handleCloseServiceDlg = () => setOpenServiceDlg(false);
  const { IndexProps } = useIndexLogic({toast,handleCloseServiceDlg,openServiceDlg, setOpenServiceDlg});  
  const {
    contentHeightFixed,
    setLoading,
    loading,
    tabValue,
    handleTabChange,
    bundleIsEmpty,
    serviceIsEmpty,
    openBundleDlg,    
    handleOpenBundleDlg,
    handleCloseBundleDlg,
    handleSaveBundle,
    openBundle,
    dummyRowsBundle,
    dummyRowsService,
    setOpenBundle,
     openDeleteConfirmation,
    handleConfirmDelete,
    handleCloseConfirmation,
    servicePaginationModel,
    setServicePaginationModel,
    columnsBundle,
    columnsService,
    handleOpenServiceDlg,
    openService,
    setOpenService,
    navigate,
    serviceList,    
    bundlePaginationModel, 
    setBundlePaginationModel,
    serviceContent,    
    ServiceProps,
    bundleContent,
    BundleProps,
    bundleList,
    pageSize,
    currentPage,
    fetchServices,
    hasMore,
    pageNumber,
    //gridApiRef,
    CustomFooter,
    handleClearSearch,
    handleSearchTextChange,
    bundleSearchText,
    handleBundleSearchTextChange,
    searchText,
    serviceData,
    bundleData,
    handleClearServiceSearch,
    handleClearBundleSearch,
  } = IndexProps;

  //#region Permissions
  const { ServicePermissionProps } = useServicePermission();
  const {
    // Service Permissions
    hasServiceSavePermission,
    hasServiceGetPermission,
    hasServiceDeletePermission,
    hasServiceSoftDeletePermission,
    hasServiceIndustriesGetPermission,

    // Bundle Permissions
    hasBundleSavePermission,
    hasBundleGetPermission,
    hasBundleDeletePermission,
    hasBundleSoftDeletePermission
  } = ServicePermissionProps;
  //#endregion Permissions
  const [collapse, setCollapse] = useState(false);
  
  

  return (
    <UserLayout contentHeightFixed={contentHeightFixed} activeLink={"Services"}>
      <Card sx={{ width: "100%", height: "100%" ,overflowX:"auto"}}>
        {/* <CardHeader
          title={
            <Typography variant="h3" sx={{ fontWeight: "bold" }}>
              Service Settings
            </Typography>
          }
        /> */}
        <CardContent
          sx={{
            p: { xs: 0, sm: 4 },
            "&:last-child": {
              pb: { xs: 0, sm: 3 },
            },
          }}
        >
          <TabContext value={tabValue}>
           <Box sx={{ width: "100%" }}>
    
    <TabList
      orientation="horizontal"
      onChange={handleTabChange}
      sx={{
        borderBottom: 1,
        justifyContent: "center",
        borderColor: "divider",
        mb: 2, // space below tabs
        "& .MuiTab-root": {
          minHeight: 40,
          px: 4,
          textTransform: "none",
        },
      }}
    >
                <Tab
                  value="1"
                  label={
                    <Box 
                      sx={{ 
                        display: "flex",
                        alignItems: "center",
                        color: theme.palette.mode === 'dark' ? 
                          tabValue === "1" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Icon
                        icon="fluent-mdl2:c-r-m-services"
                        style={{ marginRight: 8 }}
                      />
                      Services
                    </Box>
                  }
                  sx={{ alignItems: "flex-start" }}
                />
                <Tab
                  value="2"
                  label={
                    <Box 
                      sx={{ 
                        display: "flex", 
                        alignItems: "center",
                        color: theme.palette.mode === 'dark' ? 
                          tabValue === "2" ? "#fff" : "inherit" :
                          "inherit"
                      }}
                    >
                      <Icon icon="tabler:box" style={{ marginRight: 8 }} />
                      Bundles
                    </Box>
                  }
                  sx={{ alignItems: "flex-start" }}
                />
              </TabList>
              <Box>
               {/* {!isMobile && (
        <Box>
          <IconButton
            sx={{
              position: "absolute",
              left: collapse ? -10 : 125,
              top: 8,
              backgroundColor: "#a3e2b9",
              border: `1px solid ${theme.palette.divider}`,
              zIndex: 2,
              width: "30px",
              height: "30px",
              color: "primary.main",
              "&:hover": {
                backgroundColor: "#a3e2b9",
              },
            }}
            size="small"
            onClick={() => setCollapse(!collapse)}
          >
            <Icon
              icon={collapse ? "tabler:chevron-right" : "tabler:chevron-left"}
            />
          </IconButton>
        </Box>
      )} */}
              </Box>
              <TabPanel value="1" sx={{ width: "100%" }}>
                <Grid container spacing={5}   sx={{ width: "100%" }}>
                  {serviceData.length === 0 ? (
                    <Grid item xs={12}>
                      <Card sx={{ my: 6 }}>
                        <CardContent
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                            p: (theme) =>
                              `${theme.spacing(9.75, 5, 9.25)} !important`,
                          }}
                        >
                          <CustomAvatar
                            skin="light"
                            color="info"
                            sx={{ mb: 2.25 }}
                          >
                            <Icon icon="tabler:building" />
                          </CustomAvatar>
                          <Typography variant="h5" sx={{ mb: 2.75 }}>
                            No Services added yet
                          </Typography>
                          <Typography sx={{ mb: 6, color: "text.secondary" }}>
                            Add Services that are required by clicking on
                            “Create Service” button
                          </Typography>
                          <Button
                            variant="outlined"
                            color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                            startIcon={<AddIcon />}
                            disabled={!hasServiceSavePermission}
                            {...(hasServiceSavePermission && {
                              onClick: () => handleOpenServiceDlg(),
                            })}
                          >
                            Create Service
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" },
                            justifyContent: "space-between", // push left + right apart
                            alignItems: { xs: "flex-start", lg: "center" },
                            gap: 2,
                          }}
                        >
                          <Typography variant="h3">Service Settings</Typography>
                          <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" },
                            alignItems: { xs: "stretch", lg: "center" },
                            gap: 2,
                            width: { xs: "100%", lg: "auto" }
                          }}
                        >
                            <CustomTextField
                              value={searchText}
                              placeholder="Search…"
                              disabled={!hasServiceGetPermission}
                              {...(hasServiceGetPermission && {
                                onChange: (e) =>
                                  handleSearchTextChange(e.target.value),
                              })}
                              InputProps={{
                                startAdornment: (
                                  <Box sx={{ mr: 2, display: "flex" }}>
                                    <Icon
                                      fontSize="1.25rem"
                                      icon="tabler:search"
                                    />
                                  </Box>
                                ),
                                endAdornment: (
                                  <>
                                    {searchText && (
                                      <IconButton
                                        size="small"
                                        title="Clear"
                                        aria-label="Clear"
                                        onClick={handleClearServiceSearch}
                                      >
                                        <Icon
                                          fontSize="1.25rem"
                                          icon="tabler:x"
                                        />
                                      </IconButton>
                                    )}
                                  </>
                                ),
                              }}
                              sx={{
                                width: { xs: "100%", lg: "auto" },
                                maxWidth: "100%",
                                "& .MuiInputBase-root > svg": {
                                  mr: 2,
                                },
                              }}
                            />

                            <Button
                              variant="contained"
                              color="main"
                              startIcon={<AddIcon />}
                              disabled={!hasServiceSavePermission}
                              {...(hasServiceSavePermission && {
                                onClick: () => handleOpenServiceDlg(),
                              })}
                              sx={{
                                width: "auto",
                                alignSelf: { xs: "flex-start", lg: "center" },
                              }}
                            >
                              New Service
                            </Button>
                            <ImportExportOptions 
                              handleOpenBulkImportDlg={()=>{}}                          
                              data={serviceList}
                              module="Services"
                            /> 
                            
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        {/* <List component="nav" aria-label="main mailbox">
                          <ListItem
                            disablePadding
                            sx={{
                              border: "1px solid #E1E4EA",
                              borderRadius: 1,
                              pr: 4,
                            }}
                          >
                            <ListItemButton
                              onClick={() => setOpenService(!openService)}
                            >
                              <Icon
                                icon={
                                  openService
                                    ? "tabler:chevron-down"
                                    : "tabler:chevron-right"
                                }
                              />
                              <ListItemText
                                sx={{ ml: 4 }}
                                primary={
                                  <Box>
                                    <Typography
                                      variant="body1"
                                      fontWeight="bold"
                                    >
                                      Dusting
                                    </Typography>
                                  </Box>
                                }
                              />
                            </ListItemButton>
                            <Button variant="outlined" size="small">
                              Active
                            </Button>
                          </ListItem>
                          <Collapse
                            in={openService}
                            timeout="auto"
                            unmountOnExit
                          >
                            
                          </Collapse>
                        </List> */}
                        <Grid container spacing={8}>
                          <Grid item xs={12}>
                            {/* <Box
                                sx={{
                                  height: 500, 
                                  overflow: "auto", 
                                }}

                                // onScroll={(e) => {
                                //   const { scrollTop, scrollHeight, clientHeight } = e.target;
                                //   if (scrollTop + clientHeight >= scrollHeight - 10) {
                                //     if (!loading && hasMore) {
                                //       fetchServices("", pageSize, pageNumber + 1); // Load next batch
                                //     }
                                //   }
                                // }}
                              > */}
                          <DataGridPro
                              key={collapse ? "collapsed" : "expanded"}
                              rows={serviceList}
                              columns={columnsService}
                              loading={loading}
                              autoHeight
                              slots={{
                                footer: () => null
                              }}
                              disableRowSelectionOnClick
                              sx={{
                                "& .MuiDataGrid-columnHeaderTitle": {
                                  textTransform: "none",
                                },
                              }}
                            />
                            {/* </Box> */}
                          </Grid>
                          {/* <Grid item xs={12}>
                              <LineItems entity="service" />
                            </Grid> */}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </TabPanel>
              <TabPanel value="2" sx={{ width: "100%" }}>
                <Grid container spacing={5} sx={{ width: "100%" }}>
                  {bundleData.length === 0 ? (
                    <Grid item xs={12}>
                      <Card sx={{ my: 6 }}>
                        <CardContent
                          sx={{
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : "#FBFBFC",
                            p: (theme) =>
                              `${theme.spacing(9.75, 5, 9.25)} !important`,
                          }}
                        >
                          <CustomAvatar
                            skin="light"
                            color="info"
                            sx={{ mb: 2.25 }}
                          >
                            <Icon icon="tabler:building" />
                          </CustomAvatar>
                          <Typography variant="h5" sx={{ mb: 2.75 }}>
                            No Bundles added yet
                          </Typography>
                          <Typography sx={{ mb: 6, color: "text.secondary" }}>
                            Add bundles that are required by clicking on “Create
                            Bundle” button
                          </Typography>
                          <Button
                            variant="outlined"
                            color={theme.palette.mode === 'dark' ? "secondary" : "primary"}
                            startIcon={<AddIcon />}
                            disabled={!hasBundleSavePermission}
                            {...(hasBundleSavePermission && {
                              onClick: () => handleOpenBundleDlg(),
                            })}
                          >
                            Create Bundle
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" },
                            justifyContent: "space-between", // push left + right apart
                            alignItems: { xs: "flex-start", lg: "center" },
                            gap: 2,
                          }}
                        >
                          <Typography variant="h3">Service Settings</Typography>
                           <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", lg: "row" },
                            alignItems: { xs: "stretch", lg: "center" },
                            gap: 2,
                            width: { xs: "100%", lg: "auto" }
                          }}
                        >
                          <CustomTextField
                            value={bundleSearchText}
                            placeholder="Search..."
                            disabled={!hasBundleGetPermission}
                            {...(hasBundleGetPermission && {
                              onChange: (e) =>
                                handleBundleSearchTextChange(e.target.value),
                            })}
                            InputProps={{
                              startAdornment: (
                                <Box sx={{ mr: 2, display: "flex" }}>
                                  <Icon
                                    fontSize="1.25rem"
                                    icon="tabler:search"
                                  />
                                </Box>
                              ),
                              endAdornment: (
                                <>
                                  {bundleSearchText && (
                                    <IconButton
                                      size="small"
                                      title="Clear"
                                      aria-label="Clear"
                                      onClick={handleClearBundleSearch}
                                    >
                                      <Icon
                                        fontSize="1.25rem"
                                        icon="tabler:x"
                                      />
                                    </IconButton>
                                  )}
                                </>
                              ),
                            }}
                            sx={{
                              width: { xs: "100%", lg: "auto" },
                              maxWidth: "100%",
                              "& .MuiInputBase-root > svg": {
                                mr: 2,
                              },
                            }}
                          />
                          <Button
                            variant="contained"
                            color="main"
                            startIcon={<AddIcon />}
                            disabled={!hasBundleSavePermission}
                            {...(hasBundleSavePermission && {
                              onClick: () => handleOpenBundleDlg(),
                            })}
                            sx={{
                              width: "auto",
                              alignSelf: { xs: "flex-start", lg: "center" },
                            }}
                          >
                            New Bundle
                          </Button>
                        </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        {/* <List component="nav" aria-label="main mailbox">
                          <ListItem
                            disablePadding
                            sx={{
                              border: "1px solid #E1E4EA",
                              borderRadius: 1,
                              pr: 4,
                            }}
                          >
                            <ListItemButton
                              onClick={() => setOpenBundle(!openBundle)}
                            >
                              <Icon
                                icon={
                                  openBundle
                                    ? "tabler:chevron-down"
                                    : "tabler:chevron-right"
                                }
                              />
                              <ListItemText
                                sx={{ ml: 4 }}
                                primary={
                                  <Box>
                                    <Typography
                                      variant="body1"
                                      fontWeight="bold"
                                    >
                                      Basic Cleaning
                                    </Typography>
                                  </Box>
                                }
                              />
                            </ListItemButton>
                            <Button variant="outlined" size="small">
                              Active
                            </Button>
                          </ListItem>
                          <Collapse
                            in={openBundle}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Grid container spacing={5}>
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    p: 6,
                                    backgroundColor: "#F8FAFC",
                                  }}
                                >
                                  <DataGrid
                                    autoHeight
                                    hideFooter
                                    rows={dummyRowsBundle}
                                    columns={columnsBundle}
                                    disableRowSelectionOnClick
                                    sx={{
                                      "& .MuiDataGrid-columnHeaderTitle": {
                                        textTransform: "none",
                                      },
                                    }}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Collapse>
                        </List> */}
                        <Grid container spacing={8}>
                          <Grid item xs={12}>
                            <DataGridPro
                             key={collapse ? "collapsed" : "expanded"}
                              // pagination
                              autoHeight
                              // paginationModel={bundlePaginationModel}
                              // onPaginationModelChange={setBundlePaginationModel}
                              rows={bundleList}
                              columns={columnsBundle}
                              // pageSizeOptions={[
                              //   10,
                              //   50,
                              //   { label: "Show All", value: -1 },
                              // ]}
                              slots={{
                                footer: () => null
                              }}
                              disableRowSelectionOnClick
                              sx={{
                                "& .MuiDataGrid-columnHeaderTitle": {
                                  textTransform: "none",
                                },
                              }}
                            />
                          </Grid>
                          {/* <Grid item xs={12}>
                              <LineItems entity="service" />
                            </Grid> */}
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </TabPanel>
            </Box>
          </TabContext>
        </CardContent>
      </Card>

      <CreateBundleDialog
        open={openBundleDlg}
        handleClose={handleCloseBundleDlg}
        bundleContent={bundleContent}
        BundleProps={BundleProps}
        fetchServices={fetchServices}
      />
      <CreateServiceDialog
        open={openServiceDlg}
        handleClose={handleCloseServiceDlg}
        serviceContent={serviceContent}
        ServiceProps={ServiceProps}
      />
      <DeleteConfirmationDialog
        open={openDeleteConfirmation}
        handleClose={handleCloseConfirmation}
        handleConfirm={handleConfirmDelete}
      />


      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </UserLayout>
  );
};

export default Services;